<template>
  <v-ons-page id="company-history">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button></v-ons-back-button>
      </div>
      <div class="center">Company History</div>
    </v-ons-toolbar>

    <div v-if="loading" style="width: 100%; text-align: center; margin-top: 100px;">Loading...</div>

    <div id="company-history-background">
      <div v-html="html"></div>
    </div>
  </v-ons-page>
</template>


<script>
import { appData } from '../data.js'

export default {
  name: 'company-history',
  data () {
    return {
      html: '',
      loading: true
    }
  },
  created() {
    setTimeout(() => {
       this.html = appData.state.companyHistory;
    },500);
  },
  updated: function () {
    this.$nextTick(function () {
      this.loading = false;
    });
  }
}
</script>

<style scoped>
  #legal-background svg {
    width: 100%
  }
</style>


// WEBPACK FOOTER //
// src/components/CompanyHistory.vue